import { useQuery } from "@tanstack/react-query";

import TokenHelper from "@/utils/tokenHelper";
import { QUERY_KEYS } from "@api/queryKeys";

import {
  adaptPressClassification,
  adaptPressClassificationFilter,
  adaptPressClassificationName,
} from "./adaptPressClassification.data";
import { pressClassificationApi } from "./pressClassification.service";

export const usePressClassificationQuery = () => {
  const isAuthenticated = !!TokenHelper.getAccessToken();

  const query = useQuery({
    queryKey: [QUERY_KEYS.pressClassification],
    queryFn: () => pressClassificationApi.getPressClassificationData(),
    throwOnError: false,
    select: (data) => adaptPressClassification(data),
    refetchOnMount: true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 5 * 60 * 1000, // 5 minutes
    enabled: isAuthenticated,
  });
  return query;
};

export const usePressClassificationNameQuery = () => {
  const isAuthenticated = !!TokenHelper.getAccessToken();

  const query = useQuery({
    queryKey: [QUERY_KEYS.pressClassification],
    queryFn: () => pressClassificationApi.getPressClassificationData(),
    throwOnError: false,
    select: (data) => adaptPressClassificationName(data),
    refetchOnMount: true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 5 * 60 * 1000, // 5 minutes
    enabled: isAuthenticated,
  });
  return query;
};

export const usePressClassificationFilterQuery = () => {
  const isAuthenticated = !!TokenHelper.getAccessToken();

  const query = useQuery({
    queryKey: [QUERY_KEYS.pressClassification],
    queryFn: () => pressClassificationApi.getPressClassificationData(),
    throwOnError: false,
    select: (data) => adaptPressClassificationFilter(data),
    refetchOnMount: true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 5 * 60 * 1000, // 5 minutes
    enabled: isAuthenticated,
  });
  return query;
};
